import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, Menu, X } from "lucide-react";
import logo from "../images/logo.svg";
import ThemeToggle from "./ui/ThemeToggle";
import { navItems } from "../config/navItems";

const TopBar = ({ mobileOpen, setMobileOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();


  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("email");
    localStorage.removeItem("code");
    localStorage.removeItem("org");
    window.location.reload();
  };

  const handleNavigate = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  return (
    <>
      <div className="h-[60px] fixed top-0 z-40 lg:hidden w-full text-slate-900 dark:text-white flex flex-row items-center justify-between px-4 bg-white/90 dark:bg-[#0B0C12]/90 backdrop-blur-xl border-b border-black/[0.06] dark:border-white/[0.06]">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setMobileOpen((o) => !o)}
            aria-label="Toggle navigation"
            className="p-1.5 -ml-1.5 rounded-lg text-slate-500 dark:text-white/70 hover:bg-black/[0.05] dark:hover:bg-white/[0.06] transition-colors duration-200"
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
          <img src={logo} alt="logo" className="h-7" />
        </div>
        
      </div>

     
    </>
  );
};
var TopBar_default = TopBar;
export { TopBar_default as default };